import rtk, { _ } from 'rtk';
import { createActionsHook } from 'rtk/react';
import screenfull from 'screenfull';
/*
 * constants
 */
import { name } from './constants';

/* ************************ */

const { createActions, createThunks } = rtk(name);

const actions = createActions({
  error: _,
  change: _,
});
const fullscreenApi = createThunks({
  toggle: (elementId, { dispatch, getState }) => {
    const element = document.getElementById(elementId);
    // https://www.npmjs.com/package/screenfull#hide-navigation-user-interface-on-mobile-devices
    if (screenfull.isEnabled) {
      return screenfull.toggle(element || undefined); // que se passe-t-il si null ?
      // .toggle really does nothing more than .request() or .exit()
    } else {
      throw Error('fullscreen disabled');
    }
  },
  request: (elementId, { dispatch, getState }) => {
    const element = document.getElementById(elementId);
    // https://www.npmjs.com/package/screenfull#hide-navigation-user-interface-on-mobile-devices
    if (screenfull.isEnabled) {
      return screenfull.request(element || undefined); // que se passe-t-il si null ?
    } else {
      throw Error('fullscreen disabled');
    }
  },
  exit: (_, { dispatch, getState }) => {
    if (screenfull.isEnabled) {
      return screenfull.exit();
    } else {
      throw Error('fullscreen disabled');
    }
  },
});

// RTK-AUTOEXPORT
// ---- actions ---------
export const { error, change } = actions;

export const useActions = createActionsHook(actions);
// ---- thunks ---------
export const { toggle, request, exit } = fullscreenApi;

export const useFullscreenApi = createActionsHook(fullscreenApi);
